import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import CountryCode from "../CountryCode";
import EmailInput from "../EmailInput";
import PasswordInput from "../PasswordInput";
import CustomButton from "../CustomButton";

import { isValidEmail, isOnlyNumbers } from "../../utils/helpers";

import "./style.scss";

export const LoginForm = ({
  phoneNumber,
  changePhoneNumber,
  email,
  changeEmail,
  password,
  changePassword,
  onLogin,
  loginValidation,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const userName = params.get("userName") || "";

  const [selected, setSelected] = useState("mobile");

  const handleToggle = (active) => {
    setSelected(active);
  };

  const handleEmailInputChange = (e) => {
    if (changeEmail) changeEmail(e.target.value);
  };

  const handlePhoneInputChange = (value) => {
    if (changePhoneNumber) changePhoneNumber(value);
  };

  const handlePasswordChange = (e) => {
    if (changePassword) changePassword(e.target.value);
  };

  const handleSubmit = (e) => {
    if (onLogin) {
      onLogin(e, selected);
    }
  };

  useEffect(() => {
    if (!!userName) {
      setSelected(isOnlyNumbers(userName) ? "mobile" : "email");
      if (isOnlyNumbers(userName)) {
        changePhoneNumber(userName);
      } else {
        changeEmail(userName);
      }
    }
  }, [userName]);

  return (
    <form className="login-form" onSubmit={handleSubmit}>
      <div className="toggle-container-login">
        <span
          className={`toggle-label ${selected === "mobile" ? "active" : ""}`}
          onClick={() => handleToggle("mobile")}
        >
          {t("createSchedule.inviteCustomers.toggle_mobile")}
        </span>

        <div className="toggle-switch">
          <input
            type="checkbox"
            id="toggle"
            className="toggle-input"
            checked={selected === "email"}
            onChange={() =>
              handleToggle(selected === "mobile" ? "email" : "mobile")
            }
          />
          <label htmlFor="toggle" className="toggle-label-switch"></label>
        </div>

        <span
          className={`toggle-label ${selected === "email" ? "active" : ""}`}
          onClick={() => handleToggle("email")}
        >
          {t("createSchedule.inviteCustomers.toggle_email")}
        </span>
      </div>
      <div className="username-inputs">
        {selected === "mobile" ? (
          <CountryCode
            phone={phoneNumber}
            changePhone={handlePhoneInputChange}
            disability={isOnlyNumbers(userName)}
            size="medium"
          />
        ) : (
          <EmailInput
            email={email}
            label={t("input_label_email")}
            onChange={handleEmailInputChange}
            required
            disabled={isValidEmail(userName)}
            size="medium"
          />
        )}
      </div>

      <PasswordInput
        name="auth-password"
        label={t("input_label_password")}
        value={password}
        onChange={handlePasswordChange}
        required
        size="medium"
      />

      <div className="forget-password">
        <span
          onClick={() => {
            navigate("/reset");
          }}
        >
          {t("forgot_password")}
        </span>
      </div>
      <CustomButton fullWidth fontSize="1.2rem" type="submit">
        {t("login")}
      </CustomButton>

      <h3>{loginValidation}</h3>
    </form>
  );
};
